export default __webpack_public_path__ + "img/Temperature.d5e6683b.svg";